export default function Input({ label, name, type, handler, required, defaultValue, disabled }) {
    const requiredClass = required ? 'required' : '';
    return (
        <div className="form-group">
            <label className='text-uppercase'>
                {label} {required && <strong className="text-danger">*</strong>}
            </label>
            <input
                name={name}
                onChange={handler}
                type={type}
                className={`form-control ${requiredClass}`}
                value={defaultValue}
                disabled={disabled}
            />
        </div>
    )
}
